import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcadmin.research.list');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-gsdcadmin-research-list',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcadmin.research.list/view.scss */
/* src/app/portal.gsdcadmin.research.list/view.scss: no such file or directory */`],
})
export class PortalGsdcadminResearchListComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public researchs: any = [];
    public loaded: boolean = false;

    public searchTerm: any = "";

    public pagination: any = {
        page: 1,
        end: 1,
        start: 1,
    };
    public total = 0;

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.membership('admin', "/landing");
        await this.load();
    }

    public async load() {
        this.loaded = false;
        const { code, data } = await wiz.call("load", { text: this.searchTerm, page: this.pagination.page });
        if (code != 200) return await this.service.alert.error("Error!");
        this.researchs = data.rows;
        this.pagination.start = Math.floor((this.pagination.page - 1) / 10) * 10 + 1;
        this.pagination.end = data.lastpage;
        this.total = data.total;
        this.loaded = true;
        await this.service.render();
    }

    public async excel() {
        let files = await this.service.file.select({ accept: '.xlsx,.csv,.xls' });
        if (files.length == 0) return;

        await this.service.loading.show();

        for (let i = 0; i < files.length; i++) {
            let fd = new FormData();
            fd.append('upload', files[i]);
            let fdurl = '/file/upload';
            this.url = await this.service.file.upload(fdurl, fd, async (percent: number, total: number, position: number) => { });
        }

        const { code } = await wiz.call("excel", this.url);
        await this.service.loading.hide();
        if (code == 200) {
            await this.service.alert.success("성과 업로드 완료되었습니다.");
            window.location.reload();
        }
        else return await this.service.alert.error("엑셀 업로드에 실패하였습니다.");
    }

    public async download() {
        let download = wiz.url('download')
        window.location.href = download;
    }

    private async pageLoad(p: number) {
        this.pagination.page = p;
        await this.load();
    }
}

export default PortalGsdcadminResearchListComponent;